import axiosWithAuth from '@/lib/axios';
import client from '@/lib/feathers';
import type { RealtimeMessages } from '@/types/database/realtimeMessages';
import { createRealtimeMessage } from '@/utils/realtimeMessage';

export const createFeedbackMessage = async ({
  feedbackId,
  content,
  sender,
}: {
  feedbackId: string;
  content: RealtimeMessages[number]['content'];
  sender: RealtimeMessages[number]['sender'];
}) => {
  await createRealtimeMessage({
    associatedEntity: 'feedback',
    entityId: feedbackId,
    sender,
    receiver: null,
    content,
    createdTime: Date.now(),
    isRead: false,
  });
};

export const uploadImage = async (file: File) => {
  const formData = new FormData();
  formData.append('files', file);
  const { data } = await axiosWithAuth.post(
    '/newUploads?type=realtimeMessages',
    formData
  );
  return data[0].showPath;
};

export const messageIsRead = ({
  associatedEntity,
  entityId,
  senderId,
}: {
  associatedEntity: string;
  entityId: string;
  senderId: string;
}) => {
  const realtimeMessagesService = client.service('realtimeMessages');
  return realtimeMessagesService.patch(
    null,
    {
      isRead: true,
    },
    {
      query: {
        associatedEntity,
        entityId,
        'sender.id': { $ne: senderId },
        isRead: false,
      },
    }
  );
};
